export enum EDocumentStatus {
  Valid = 0,
  Invalid = 1,
  Deleted = 2,
}

export interface IDocument {
  id: number;
  folderId: number;
  folderName: string;
  fileName: string;
  fileHash: string;
  fileStatus: EDocumentStatus;
  fileCreateTime: number;
  fileUpdateTime: number;
}

export interface IFolder {
  id: number;
  folderName: string;
  fileName: string[];
  fileHash: string[];
  fileStatus: EDocumentStatus[];
  folderOwner: string;
  fileCreateTime: number[];
  fileUpdateTime: number[];
  folderCreateTime: number;
  folderUpdateTime: number;
}
